import React,{useState} from 'react';
import {Card,HTMLRenderer,Button} from '../../components/';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {FormatDate} from '../../Utils/';
import {useHistory} from 'react-router-dom';



const Content = ({tokenObject,connection}) => {

    const [Content,setContent] = useState([]);
    const [Category,setCategory] = useState([]);
    const [filterCategory,setFilterCategory] = useState("");
    const [wasAssigned,setWasAssigned] = useState(false);

    const [ContentSearch,setContentSearch] = useState("");

    const history = useHistory();

    function handleContentSearch(event){
        setContentSearch(event.target.outerText);
    }

    function SearchContent(){
        history.push('/Content?'+ContentSearch);
    }

    function handleCategory(e){
        setFilterCategory(e.target.value);
    }

    function handleSearchBar(event){
        document.getElementById("InputSearch").value = event.target.outerText;
        setContentSearch(event.target.outerText);
    }

    if(tokenObject.token === ""){
        return(
            <Redirect to="/login"/>
        );
    }

    async function GetContents(){

        let ContentResult;

        if(filterCategory !== ""){
            ContentResult = await connection.get('/Contents',{
                headers:{
                    'user-access-token':tokenObject.token
                },
                params:{
                    Category:filterCategory
                }
            });
        }else{
            ContentResult = await connection.get('/Contents',{
                headers:{
                    'user-access-token':tokenObject.token
                },
            });
        }
        

        const CategoryResult = await connection.get('/Categories',{
            headers:{
                'user-access-token':tokenObject.token
            } 
        });

        if(wasAssigned === false){
            setWasAssigned(true);

            let localContents = [];
            let localCategories = [];

            CategoryResult.data.forEach((value,key) => {
                localCategories.push(value);
            })

            ContentResult.data.forEach((value,key) =>{
                localContents.push(value);
            });

            setCategory(localCategories);
            setContent(localContents);
        }
            
    };

    GetContents();

    return(
        <Card>
            <br/>
                <center><h1>Conteúdos</h1></center>
                <div class="input-group mb-3">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Contents</button>
                    <ul class="dropdown-menu">
                        {Content.map((value,index) => (
                            <>
                                <li><a class="dropdown-item" onClick={handleSearchBar}>{value.Title}</a></li>
                                <li><hr class="dropdown-divider"/></li>
                            </>
                            ))}
                    </ul>
                    <input type="text" class="form-control" id="InputSearch" aria-label="Text input with dropdown button" onChange={handleContentSearch}/>
                    <button className="btn btn-outline-primary" onClick={SearchContent}>Search</button>
                </div>
                <div class="input-group mb-3">
                <select class="form-select" aria-label="Default select example" onChange={handleCategory}>
                    <option value = "">No filter</option>
                    {Category.map((value,index) => (
                            <option key={index} value={value.Name}>{value.Name}</option>

                    ))}
                </select>
                <Button type="secondary" isOutline={true} onClick={() => {setWasAssigned(false)}}>Filter</Button>
                </div>
               
                

                <br/>
                <br/>
                {Content.map((value,index) => (
                    <Card key={index}>
                    <p>
                        <button className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target={"#collapseExample"+index} aria-expanded="false" aria-controls="collapseExample">
                            {value.Title}
                        </button>
                    </p>
                    <div className="collapse" id={"collapseExample"+index}>
                        <div className="card card-body" >
                            <HTMLRenderer Content={value.Content}/>
                            <small className="text-muted">{FormatDate(value.Created_at)}</small>
                        </div>
                    </div>
                    <br/>
                    </Card>
                ))}
            <br/>
            {}
        </Card>

    )
}


const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps)(Content);